import React from "react";
import { Upload, Icon, Row, Col } from "antd";

import styles from "./multiplePhotos.scss";
import { compressImageRequest } from "../compressImageRequest";
import ImageCard from "./ImageCard";
import { getImageLink } from "../../../../services/asset";

// eslint-disable-next-line max-lines-per-function
const MultiplePhotos = ({
  uploadClassName,
  previewCardClassName,
  isCompressed,
  isDisabled,
  files,
  onChange,
  onMove,
  onPreview,
  onRemove,
  beforeUpload,
  action,
  accept,
  maxPhotoNumber
}) => (
  <Row gutter={8} style={{ marginBottom: "20px" }}>
    {files.map((file, index) => (
      <Col style={{ maxWidth: "150px" }} key={file.uid} xs={12} md={8} lg={6}>
        <ImageCard
          className={previewCardClassName}
          disabled={isDisabled}
          draggable
          index={index}
          onMove={onMove}
          status={file.status}
          imageUrl={
            file.url || (file.response ? getImageLink(file.response[0]) : null)
          }
          onPreview={onPreview}
          onRemove={onRemove}
        />
      </Col>
    ))}
    <Col style={{ maxWidth: "150px" }} xs={12} md={8} lg={6}>
      <Upload
        disabled={isDisabled}
        action={action}
        className={`multiple-photos-uploader ${styles.uploader} ${uploadClassName}`}
        listType="picture-card"
        fileList={files}
        onPreview={onPreview}
        onChange={onChange}
        beforeUpload={beforeUpload}
        accept={accept}
        multiple
        /* eslint-disable-next-line */
        customRequest={compressImageRequest.bind(this, isCompressed)}
        showUploadList={false}
      >
        {files.length < maxPhotoNumber ? (
          <Icon type="plus" className={styles.addPhoto} />
        ) : null}
      </Upload>
    </Col>
  </Row>
);

MultiplePhotos.defaultProps = {
  uploadClassName: "",
  onChange: () => null,
  isCompressed: true,
  isDisabled: false,
  previewCardClassName: "",
  maxPhotoNumber: 8
};

export default MultiplePhotos;



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/MultiplePhotos/index.tsx